module.exports = "https://cdn.redage.net/src/views/player/documets/lspdbadge/images/6.png";